import Vue from 'vue'
import confirmTransfomer from '@/transformers/taxReceipt/confirmRequestCancel'

/**
 * @author José Luis R. <jose.ruiz@jbge.com.mx>
 *
 * Confirm request cancellation of an invoice
 *
 * @param  payload
 * @return {Array} File's info
 */

const confirmRequestCancel = payload =>
  Vue.$http.post('taxreceipt/cancellation-confirmation/', confirmTransfomer.send(payload))
    .then()
    .catch((err) => {
      throw err
    })

export default confirmRequestCancel


// WEBPACK FOOTER //
// ./src/services/taxReceipt/confirmRequestCancel.js